import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="info-page">
      <p className="mono" style={{ color: 'var(--gold)', marginBottom: '8px' }}>OUR STORY</p>
      <h1>About Frame My Balls</h1>

      <p>We're a small workshop in Phoenix, Arizona, 3D-printing modular golf ball display racks for collectors who want to show off their finds.</p>

      <h3>The Idea</h3>
      <p>Every golfer has a story behind their favorite ball — an ace, a course they'll never forget, a round with someone special. We built a better way to display those memories: wall-mounted racks that hold five balls each and stack as your collection grows.</p>

      <h3>How They're Made</h3>
      <p>Each module is 3D-printed in-house. We sand, finish, and inspect every piece before it ships. Available in six colors to match your space.</p>

      <h3>Modular Means Flexible</h3>
      <p>Start with a single rack. Add modules vertically whenever you want. Our mounting system keeps everything aligned and secure. No woodworking, no custom shelving — just screw in a module and drop in your balls.</p>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Link to="/shop" className="btn btn-primary">Shop Now</Link>
      </div>
    </div>
  );
}
